import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import {
  deletePlan,
  EnergyConsumptionAdminList,
  getPlanDetail,
  PlanDetailResponse,
  PlanOfMediumListVO,
} from '@/api/energy';
import { Button, Dialog, Empty, Tabs } from 'antd-mobile';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import NoData from '@/assets/images/noData.png';
import { useSyncHorizontalScroll } from '../EnergyUseManagement/components/list/hook';
import { formatTimeRange } from '../EnergyUsePlan/util';

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const editable = searchParams.get('editable');
  const code = searchParams.get('code');
  const [activeTab, setActiveTab] = useState<string>();
  const [dateRange, setDateRange] = useState<Array<string>>();

  const [mediumList, setMediumList] = useState<EnergyConsumptionAdminList[]>();
  const [planOfMediumList, setPlanOfMediumList] = useState<PlanDetailResponse['energyConsumptionPlanOfMediumList']>();
  const [curTabData, setCurTabData] = useState<PlanOfMediumListVO['ownerOrgInfoVoList']>();

  const scrollRefs = useSyncHorizontalScroll(curTabData, activeTab);

  useEffect(() => {
    document.title = `${code}详情`;
  }, [code]);

  useEffect(() => {
    if (!id) return;
    getPlanDetail({ id: id! }).then(res => {
      if (!isEmpty(res.energyConsumptionPlanOfMediumList)) {
        const data = res.energyConsumptionPlanOfMediumList;
        setDateRange(
          data?.[0]?.ownerOrgInfoVoList?.[0]?.areaInfoVoList?.[0]?.timeDetailVoList?.map(i => i.date!) ?? []
        );
        const mediumData = data!.map((item: any) => ({
          energyMediumId: item.mediumId,
          energyMediumName: item.mediumName,
        }));
        setMediumList(mediumData ?? []);
        setActiveTab(mediumData?.[0]?.energyMediumId?.toString() || '0');
        setCurTabData(data?.[0]?.ownerOrgInfoVoList);
        setPlanOfMediumList(data ?? []);
      }
    });
  }, [id]);

  useEffect(() => {
    if (!isEmpty(planOfMediumList)) {
      setCurTabData(planOfMediumList?.find(item => item.mediumId == activeTab)?.ownerOrgInfoVoList);
    }
  }, [activeTab]);

  return (
    <div className={styles.detail}>
      <div className={styles.header}>
        <div className={styles.dateRange}>
          日期范围
          <span style={{ color: '#333333' }}>
            {dateRange?.[0]}~{dateRange?.[6]}
          </span>
        </div>
        <Tabs activeKey={activeTab} onChange={setActiveTab} className="tabs">
          {mediumList?.map(medium => (
            <Tabs.Tab title={medium.energyMediumName} key={String(medium.energyMediumId)} />
          ))}
        </Tabs>
      </div>
      {!isEmpty(planOfMediumList) ? (
        curTabData?.map(item => (
          <div key={item.ownerOrgId} className={styles.list}>
            <div className={styles.title}>{item.ownerOrgName}</div>
            {item.areaInfoVoList?.map((area, index) => (
              <div className={styles.card}>
                <div className={styles.subTitle}>{area.areaName}</div>
                <div className={styles.cardContent} ref={el => (scrollRefs.current[`${area.areaId}${index}`] = el)}>
                  {area?.timeDetailVoList?.map(time => (
                    <div className={styles.cartItem}>
                      <div className={styles.dayTitle}>{time?.date}</div>
                      <div className={styles.areaDay}>
                        {!isEmpty(time?.detailList) ? (
                          time!.detailList!.map(detail => (
                            <div className={styles.energyItem}>
                              {formatTimeRange(time.date!, detail.startDateTime!, detail.endDateTime!)}
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: 11, color: '#ccc' }}>暂无计划</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        <div className={styles.emptyState}>
          <Empty image={NoData} description="暂无数据" />
        </div>
      )}
      {editable === 'true' && (
        <div className={styles.actionBar}>
          <Button
            size="large"
            onClick={() => {
              Dialog.confirm({
                content: '确定要删除该用能计划？',
                onConfirm: () => {
                  deletePlan(id!).then(() => navigate('/intelligent-platform/energyUse/plan/list'));
                },
              });
            }}
          >
            删除
          </Button>
          <Button
            size="large"
            color="primary"
            fill="solid"
            onClick={() => navigate(`/intelligent-platform/energyUse/plan/${id}`)}
          >
            编辑
          </Button>
        </div>
      )}
    </div>
  );
};

export default Detail;
